import React from "react";

import { DeviceDetector } from "@utils";
import classNames from "classnames";

import { isOverlayMode } from "../config/LiveStreamConfig";
import { FullScreenButton } from "./FullScreenButton";
import { MuteButton } from "./MuteButton";
import { PlayPauseButton } from "./PlayPauseButton";

export function LiveStreamActionButtons(props: {
	playerId: string;
	pausedStatus: boolean;
	setPausedState: (paused: boolean) => void;
	onExpand: () => void;
	isOverlayOpen: boolean;
	muted: boolean;
	toggleMute: () => void;
}) {
	const {
		playerId,
		pausedStatus,
		setPausedState,
		onExpand,
		isOverlayOpen,
		muted,
		toggleMute,
	} = props;

	if (isOverlayMode()) {
		// PC + tablet: overlay mode — no FullScreenButton
		return (
			<div
				className={classNames("widget__actions", {
					"widget__actions--over": !DeviceDetector.isMobileTheme,
				})}
			>
				<PlayPauseButton
					playerId={playerId}
					pausedStatus={pausedStatus}
					setPausedState={setPausedState}
					onExpand={onExpand}
					isOverlayOpen={isOverlayOpen}
				/>
				<MuteButton muted={muted} toggleMute={toggleMute} />
			</div>
		);
	}

	// Mobile phone only: native fullscreen
	return (
		<div
			className={classNames("widget__actions", {
				"widget--ls__actions": DeviceDetector.isMobileTheme,
			})}
		>
			<PlayPauseButton
				playerId={playerId}
				pausedStatus={pausedStatus}
				setPausedState={setPausedState}
			/>
			<MuteButton muted={muted} toggleMute={toggleMute} />
			<FullScreenButton playerId={playerId} />
		</div>
	);
}
